import { IDepositWidgetParams } from './depositWidget';

export interface IPaymentWidgetMicrofrontendAPI {
  openDepositModal(parameters: IDepositWidgetParams): Promise<TPaymentWidgetResult>;
}

export const enum EPaymentWidgetResultStatus {
  /** Оплата прошла успешно */
  Success = 'success',
  /** Оплата завершилась с ошибкой */
  Fail = 'fail',
  /** Пользователь отказался от оплаты (закрыл модалку) */
  Cancel = 'cancel',
}

export type TPaymentWidgetResult = IWidgetResultSuccess | IWidgetResultFail | IWidgetResultCancel;

export interface IWidgetResultSuccess {
  status: EPaymentWidgetResultStatus.Success;
  paymentId: string;
  transactionId: string | undefined;
  provider: EPaymentProvider;
}

export interface IWidgetResultFail {
  status: EPaymentWidgetResultStatus.Fail;
}

export interface IWidgetResultCancel {
  status: EPaymentWidgetResultStatus.Cancel;
}

export enum EPaymentProvider {
  YooKassa = 'yooKassa',
  CloudPayments = 'cloudPayments',
}
